import { createContext, useState, useEffect, useContext } from 'react';
import { TasksContext } from './tasks-context';
import { postIsRead } from '../common/api-requests';

const ReadContext = createContext(null);

const ReadProvider = ({ children }) => {

    const [tasks, setTasks] = useContext(TasksContext);
    const [read, setRead] = useState([]);

    useEffect(() => {

        if (!read || !read.length)
            return;

            postIsRead(read).then(() => {

                if (tasks && tasks.length && tasks.some(task => read.some(id => id === task.id))){
                    let tasksUpd = [...tasks];

                    for (let i = 0; i < tasksUpd.length; i++) {
                        for (let j = 0; j < read.length; j++) {

                            if (tasksUpd[i].id === read[j])
                                tasksUpd[i].isRead = true;
                        }
                    }

                    setTasks(tasksUpd);
                }
            });

    }, [read]);

    return (
        <ReadContext.Provider value={[read, setRead]}>
            {children}
        </ReadContext.Provider>
    )
}

export { ReadContext, ReadProvider };

